import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Logo from '../Logo/Logo'
import CookiesNotAllowedIllustration from '../../Assets/Illustrations/CookiesNotAllowedIllustration'
import useWindowSize from '../../hooks/useWindowSize'
import { useStyles } from './CookiesNotAllowedStyles'

function CookiesNotAllowed({ reason }) {
  const windowSize = useWindowSize()
  const classes = useStyles()

  useEffect(() => {
    window?.gtag('event', 'quiz_load_failed', {
      event_category: 'Cookies not allowed',
      event_label: 'Cookies not allowed',
    })
  }, [])

  return (
    <Grid
      container
      direction="column"
      className={classes.root}
      style={{ height: `${windowSize?.height}px` }}
    >
      <Helmet>
        <title>Cookies not allowed</title>
      </Helmet>
      <Grid container alignItems="center" className={classes.header}>
        <Logo />
      </Grid>
      <Grid container alignItems="center" className={classes.body}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          className={classes.illustrationAndTextWrapper}
        >
          <Grid item className={classes.illustrationWrapper}>
            <CookiesNotAllowedIllustration />
          </Grid>
          <Grid item className={classes.textWrapper}>
            <Typography className={classes.text}>{reason}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CookiesNotAllowed
